'use strict';

import { ElementValuesAction } from '../../../../../app/resources/element/element-value/element-values-action.interface';
import { ElementOptionsAction } from '../../../../../app/resources/element/element-options/element-options-action.interface';

(function() {
  angular
    .module('specsguardApp')
    .controller('matrixElementValue', matrixElementValue);

    matrixElementValue.$inject = ['$scope', 'sg2AuthService', 'Labels', 'sg2ElementService'];

    function matrixElementValue($scope, sg2AuthService, Labels, sg2ElementService) {
      const vm = this;
      vm.status = false;
      vm.LABELS = Labels;

      $scope.canUpdateElement = sg2AuthService.canUpdate('element');

      vm.elementViewType = ( isCustom ) => {
        return isCustom ? 'area' : 'basicArea';
      };

      vm.setDisabled = ( element ) => {
        if ( typeof element !== 'undefined' ) {
          return element.projectLevel !== 5;
        }
        return false;
      };


      const sg2ElementComponentsActions = {
        edit: (element) => sg2ElementService.getElement(element._id, { identifier: element.identifier }),
        restoreArea: (element) => sg2ElementService.getElement(element._id, { projectLevel: 4 }),
      };

      /**
       * On new element value update.
       *
       * @param action The action dispatched from the options menu.
       */
      vm.updateElementOption = (action: ElementValuesAction) => {
        $scope.$emit('sg2UpdateElementOption', action);
      };

      /**
       * When emitted we need to actually update the element
       */
      $scope.$on('sg2UpdateElementOption', function(event: Event, action: ElementOptionsAction) {
        const { element, action: type } = action;
        vm.selectedElement = sg2ElementComponentsActions[type](element);
      });

      /**
       *
       * make sure that the correct element is loaded.
       */
      vm.getElement = (item) => {
        let element = {};

        element = Object.assign({}, $scope.selectedElements.find(elm => {
          if ( elm.name === $scope.item.name ) {
            return elm;
          }
         }));

        if (element.hasOwnProperty('_id')) {
          vm.status = true;
        } else {
          element = {
            value: null,
          };
        }
        vm.selectedElement = element;
        return element;
      };
    }
})();
